import { useForm } from "react-hook-form";

/**
 * Generic react-hook-form wrapper that can render any form inputs in its children
 * @returns
 */
export default function FormComponent({
  children,
  defaultValues,
  id,
  onFormSubmit,
}) {
  const {
    clearErrors,
    formState: { errors, isDirty, isValid },
    handleSubmit,
    register,
    reset: resetForm,
    setError,
    setValue,
    trigger,
    watch,
  } = useForm({ defaultValues, mode: "onChange" });

  const handleFormSubmit = (formData) => {
    onFormSubmit(formData);
  };

  const formData = watch();
  return (
    <form data-testid={id} id={id} onSubmit={handleSubmit(handleFormSubmit)}>
      {children({
        clearErrors,
        defaultValues,
        errors,
        formData,
        isDirty,
        isValid,
        register,
        resetForm,
        setError,
        setValue,
        trigger,
      })}
    </form>
  );
}
